import React, { useState, useEffect } from "react";
import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";

import Icon from "../Icons";

type Place = {
  place_id: string;
  name: string;
  location: google.maps.LatLng | google.maps.LatLngLiteral;
  types: string[];
  icon?: {
    url: string;
    background: string;
  };
  rating?: number;
  user_ratings_total?: number;
};

export default function NewMap({ geo_location, locations }: any) {
  const [selectedPlace, setSelectedPlace] = useState<Place | null>(null);
  const [nearbyPlaces, setNearbyPlaces] = useState<Place[]>([]);
  const [navOpen, setNavOpen] = useState(false);

  const position = geo_location && {
    lat: parseFloat(geo_location[0]),
    lng: parseFloat(geo_location[1]),
  };

  // ✅ Copy Google Maps URL
  // const handleCopyLocation = () => {
  //   if (!position) return;

  //   const shareUrl = `https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}`;
  //   navigator.clipboard.writeText(shareUrl);

  //   alert("✅ Location copied to clipboard!");
  // };

  // const handleNavigate = () => {
  //   if (!position) return;

  //   const navUrl = `https://www.google.com/maps/dir/?api=1&destination=${position.lat},${position.lng}`;
  //   window.open(navUrl, "_blank");
  // };

  // Copy Link
  const handleCopyLocation = () => {
    if (!position) return;

    const shareUrl = `https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}`;
    navigator.clipboard.writeText(shareUrl);
    alert("✅ Location copied!");
  };

  // const handleNavigate = () => {
  //   if (!position) return;
  //   const navUrl = `https://www.google.com/maps/dir/?api=1&destination=${position.lat},${position.lng}`;
  //   window.open(navUrl, "_blank");
  // };

  // Start Navigation using GPS
  // const handleStartNavigation = () => {
  //   if (!position) return;

  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((loc) => {
  //       const { latitude, longitude } = loc.coords;

  //       const navUrl = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${position.lat},${position.lng}`;
  //       window.open(navUrl, "_blank");
  //     });
  //   } else {
  //     alert("Geolocation is not supported by your device.");
  //   }
  // };

  // Google Maps Navigation
  // const handleGoogleMaps = () => {
  //   const url = `https://www.google.com/maps/dir/?api=1&destination=${position.lat},${position.lng}`;
  //   window.open(url, "_blank");
  // };

  // Apple Maps Navigation
  // const handleAppleMaps = () => {
  //   const url = `https://maps.apple.com/?daddr=${position.lat},${position.lng}`;
  //   window.open(url, "_blank");
  // };

  // WhatsApp Share
  
  const handleWhatsAppShare = () => {
    const text = `📍 Location:\nhttps://www.google.com/maps?q=${position.lat},${position.lng}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const centerPosition =
    locations && locations.length > 0
      ? {
          lat:
            locations.reduce(
              (sum: number, loc: any) => sum + parseFloat(loc.geo_location[0]),
              0,
            ) / locations.length,
          lng:
            locations.reduce(
              (sum: number, loc: any) => sum + parseFloat(loc.geo_location[1]),
              0,
            ) / locations.length,
        }
      : position;

  return (
    <div className="w-full h-full relative">
      {/* Google Maps Style Navigation FAB */}
      <div className="absolute z-50 top-20 right-2 flex flex-col items-end">
        {/* Floating Action Button */}
        <div className="flex w-11 h-11 rounded-full bg-white shadow-md justify-center items-center">
          <Icon
            name="ic-share"
            className=" w-4 h-4 cursor-pointer"
            onClick={() => setNavOpen(!navOpen)}
          />
        </div>

        {/* Sliding Menu */}
        <div
          className={`mt-3 w-32 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden transform transition-all duration-300 ${
            navOpen
              ? "opacity-100 scale-100"
              : "opacity-0 scale-95 pointer-events-none"
          }`}
        >
          <div className="py-2">
            {/* <MenuItem
          icon="navigation"
          title="Start Navigation"
          // onClick={handleStartNavigation}
          onClick={handleNavigate}
        /> */}
            {/* <MenuItem
          icon="map"
          title="Open in Google Maps"
          onClick={handleGoogleMaps}
        /> */}
            {/* <MenuItem
          icon="directions"
          title="Open in Apple Maps"
          onClick={handleAppleMaps}
        /> */}
            <MenuItem
              icon="ic-whatsApp"
              title="Share"
              onClick={handleWhatsAppShare}
            />
            <MenuItem
              icon="ic-copy"
              title="Copy"
              onClick={handleCopyLocation}
            />
          </div>
        </div>
      </div>
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        <Map
          defaultCenter={centerPosition || position}
          defaultZoom={locations && locations.length > 1 ? 10 : 16}
          mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
          gestureHandling="greedy"
          disableDefaultUI={false}
        >
          {/* Single location marker */}
          {position && !locations && (
            <AdvancedMarker position={position}>
              <Pin
                background={"#22ccff"}
                borderColor={"#1e89a1"}
                glyphColor={"#0f677a"}
              />
            </AdvancedMarker>
          )}

          {/* Multiple location markers */}
          {locations &&
            locations.map((loc: any, index: number) => {
              const markerPosition = {
                lat: parseFloat(loc.geo_location[0]),
                lng: parseFloat(loc.geo_location[1]),
              };
              return (
                <AdvancedMarker key={index} position={markerPosition}>
                  <Pin
                    background={"#008564"}
                    borderColor={"#006b50"}
                    glyphColor={"#004d3a"}
                  />
                </AdvancedMarker>
              );
            })}

          {/* Nearby Places Fetch */}
          <NearbyPlaces onPlacesFound={(places) => setNearbyPlaces(places)} />

          {/* Selected Place Directions */}
          {selectedPlace && (
            <>
              <Directions destination={selectedPlace} />
              <div className="place-info-box">
                <h3>{selectedPlace.name}</h3>
                <button onClick={() => setSelectedPlace(null)}>✕</button>
                {selectedPlace.rating && (
                  <div>Rating: {selectedPlace.rating} ★ </div>
                )}
              </div>
            </>
          )}

          {/* Nearby Places Markers */}
          {nearbyPlaces.map((place) => (
            <AdvancedMarker key={place.place_id} position={place.location}>
              <div style={{ position: "relative", width: 40, height: 40 }}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    background: place.icon?.background || "#4285F4",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {place.icon ? (
                    <img
                      src={place.icon.url}
                      style={{ width: 20, height: 20 }}
                    />
                  ) : null}
                </div>

                {place.rating && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: -8,
                      right: -8,
                      background: "white",
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      fontWeight: "bold",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                    }}
                  >
                    {place.rating.toFixed(1)}
                  </div>
                )}
              </div>
            </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
    </div>
  );
}

/* ---------------------- NEARBY PLACES ---------------------- */

interface NearbyPlacesProps {
  onPlacesFound: (places: Place[]) => void;
}

const NearbyPlaces: React.FC<NearbyPlacesProps> = ({ onPlacesFound }) => {
  const map = useMap();
  const placesLib = useMapsLibrary("places");

  useEffect(() => {
    if (!placesLib || !map) return;

    const service = new placesLib.PlacesService(map);
    const typesToSearch = ["restaurant", "atm", "hospital", "school"];
    const allResults: Place[] = [];
    const MAX_RESULTS_PER_CATEGORY = 8;
    let completedRequests = 0;

    typesToSearch.forEach((type) => {
      const request = {
        location: map.getCenter(),
        radius: 1500,
        type,
        rankBy: google.maps.places.RankBy.PROMINENCE,
        fields: [
          "name",
          "geometry",
          "place_id",
          "types",
          "icon_mask_base_uri",
          "icon_background_color",
          "rating",
          "user_ratings_total",
        ],
      };

      service.nearbySearch(request, (results, status) => {
        completedRequests++;

        if (status === "OK" && results) {
          const sortedResults = results
            .sort((a, b) => {
              const aScore = (a.rating || 0) * (a.user_ratings_total || 1);
              const bScore = (b.rating || 0) * (b.user_ratings_total || 1);
              return bScore - aScore;
            })
            .slice(0, MAX_RESULTS_PER_CATEGORY);

          const placesWithIcons = sortedResults.map((place) => ({
            place_id: place.place_id || "",
            name: place.name || "",
            location: place.geometry?.location || map.getCenter(),
            types: place.types || [],
            icon: place.icon_mask_base_uri
              ? {
                  url: `${place.icon_mask_base_uri}.svg`,
                  background: place.icon_background_color || "#4285F4",
                }
              : undefined,
            rating: place.rating,
          }));

          allResults.push(...placesWithIcons);
        }

        if (completedRequests === typesToSearch.length) {
          const finalResults = allResults
            .sort((a, b) => {
              const priority: Record<string, number> = {
                hospital: 3,
                school: 2,
                restaurant: 1,
                atm: 0,
              };

              const aType = a.types[0] || "";
              const bType = b.types[0] || "";
              return (priority[bType] || 0) - (priority[aType] || 0);
            })
            .slice(0, 12);

          onPlacesFound(finalResults);
        }
      });
    });
  }, [placesLib, map]);

  return null;
};

/* ---------------------- DIRECTIONS RENDERING ---------------------- */

interface DirectionsProps {
  destination: Place;
}

const Directions: React.FC<DirectionsProps> = ({ destination }) => {
  const map = useMap();
  const routesLib = useMapsLibrary("routes");
  const [directionsRenderer, setDirectionsRenderer] =
    useState<google.maps.DirectionsRenderer | null>(null);
  console.log(directionsRenderer);

  useEffect(() => {
    if (!routesLib || !map) return undefined;

    const directionsService = new routesLib.DirectionsService();
    const renderer = new routesLib.DirectionsRenderer({
      map,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: "#4285F4",
        strokeWeight: 4,
      },
    });

    setDirectionsRenderer(renderer);

    directionsService.route(
      {
        origin: map.getCenter(),
        destination: destination.location,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === google.maps.DirectionsStatus.OK && response) {
          renderer.setDirections(response);
        }
      },
    );

    return () => {
      renderer.setMap(null);
    };
  }, [routesLib, map, destination]);

  return null;
};

const MenuItem = ({ icon, title, onClick }: any) => (
  <button
    onClick={onClick}
    className="w-full flex items-center gap-4 px-4 py-3 hover:bg-gray-100 active:bg-gray-200 transition-all"
  >
    {/* <span className="material-icons-outlined text-gray-700 text-2xl">
      {icon}
    </span> */}
    <Icon name={icon} className=" w-4 h-4 cursor-pointer" />
    <span className="text-gray-900 font-medium">{title}</span>
  </button>
);
